export default "__VITE_ASSET__DZaaCRde__"